import {NgModule} from '@angular/core'
import {Routes, RouterModule, RouteReuseStrategy} from '@angular/router'
import {ProjectComponent} from './project.component'
import {ProjectEditComponent} from './project-edit/project-edit.component'
import {CreativeComponent} from '../creative/creative.component'
import {CustomReuseStrategy} from '../routing/route-reuse-strategy'

const routes: Routes = [
  {
    path: 'project/:projectId',
    component: ProjectComponent,
    children: [
      {
        path: 'creative/:creativeId',
        component: CreativeComponent,
      },
    ],
  },
  {
    path: 'project/:projectId/edit',
    component: ProjectEditComponent,
  },
  {
    path: 'project/:projectId/edit/:clientId',
    component: ProjectEditComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: CustomReuseStrategy,
    },
  ],
  exports: [RouterModule],
})
export class ProjectRoutingModule {}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/project/project-routing.module.ts